import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import styles from './applicant-to-recruiter-message.module.css'; // Use CSS modules
import NavHeader from '../shared/Nav-Header';
import { io } from 'socket.io-client';
// import defaultProfile3 from '../images/default-profile3.jpg';


const getSocketURL = () => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_API_URL || 'https://server-production-e45c.up.railway.app/';
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:5000';
};

const socket = io(getSocketURL(), { 
  transports: ['websocket', 'polling'],
  withCredentials: true // Important for CORS with credentials
});

const GuestApplicantToRecruiterMessage = () => {
    const [recruiters, setRecruiters] = useState([]);
    const [messages, setMessages] = useState([]);
    const [recentMessage, setRecentMessage] = useState('');
    const [activeChat, setActiveChat] = useState(null);
    const [currentRoomId, setCurrentRoomId] = useState(null);
    const [showOptions, setShowOptions] = useState(null);
    const [userId, setUserId] = useState('');
    const bottomRef = useRef(null);

    useEffect(() => {
        const fetchRecruiters = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get('/api/guest/applicant-to-recruiter-message/all-recruiters');
                // console.log(response.data.recruiters);
                // console.log(response.data.userId);
                setRecruiters(response.data.recruiters);
                setUserId(response.data.userId);
            } catch (error) {
                // console.error('Error fetching recruiters:', error);
            }
        };

        fetchRecruiters();
    }, []);

    useEffect(() => {
        if (!currentRoomId) return;

        socket.emit('joinRoom', { roomId: currentRoomId });

        socket.on('receiveMessage', (newMessage) => {
            setMessages((prevMessages) => [...prevMessages, newMessage]);
        });

        return () => {
            socket.off('receiveMessage');
            if (currentRoomId) {
                socket.emit('leaveRoom', { roomId: currentRoomId });
            }
        };
    }, [currentRoomId]);

    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const startChat = async (user1, user2) => {
        // console.log('Starting chat between: user1:', user1._id,'user2:', user2);
        const userId1 = user1._id
        try {
            const response = await axios.post('/api/guest/applicant-to-recruiter-message/start-chat', { userId1, user2 }
            );

            if (response.data.success) {
                return response.data.room;
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Error starting chat:';//Fe full error.?response?.data?.message specific error message
            console.error(errorMessage);
            // console.error('Error starting chat:', error);
        }
    };

    const fetchOlderMessages = async (currentRoomId) => {
        try {
            const token = localStorage.getItem('token');
            // console.log('Fetching old messages for room:', currentRoomId);
            const response = await axios.post('/api/guest/applicant-to-recruiter-message/get-messages',
                { currentRoomId }
            );
            console.log('response:fe0', response);
            if (response.data.success) {
                console.log('Fetched messages:fe1', response.data.messages);
                const filteredMessages = response.data.messages.filter(msg => !msg.deletedFor.includes(response.data.userId));
                // const filteredMessages = response.data.messages;
                console.log('Fetched messages:fe2', filteredMessages);
                setMessages(filteredMessages);
            }
        } catch (error) {
            console.error('Error fetching old messages:', error);
        }
    };

    const handleChatClick = async (recruiter) => {

        setActiveChat(recruiter);
        if (!userId) return;

        if (currentRoomId) {
            socket.emit('leaveRoom', { roomId: currentRoomId });
        }

        try {
            const room = await startChat(userId, recruiter._id);
            if (room) {
                console.log('Chat room:', room);
                setActiveChat(recruiter);
                setCurrentRoomId(room._id);
                socket.emit('joinRoom', { roomId: room._id });
                fetchOlderMessages(room._id);
            }
        } catch (error) {
            console.error('Error handling chat click:', error);
        }
    };

    const sendMessage = async () => {
        setRecentMessage('');
        return;
        if (!recentMessage.trim() || !currentRoomId || !userId || !activeChat?._id) {
            console.error("Missing required fields:", { currentRoomId, userId, activeChat, recentMessage });
            return;
        }

        try {
            const token = localStorage.getItem('token');
            const receiverId = activeChat._id;

            const requestData = {
                roomId: currentRoomId,
                senderId: userId,
                receiverId,
                message: recentMessage
            };

            const response = await axios.post('/api/applicant-to-recruiter-message/send-message', requestData, {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data.success) {
                const newMessage = response.data.newMessage;
                socket.emit('sendMessage', newMessage);
                setMessages((prevMessages) => [...prevMessages, newMessage]);
            }
        } catch (error) {
            console.error("Error sending message:", error.response?.data || error.message);
        }
    };

    const handleDeleteMessageForAll = async (messageId) => {
        return;
        try {
            const token = localStorage.getItem('token');
            await axios.post('/api/applicant-to-recruiter-message/delete-message-for-all', { messageId }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setMessages((prevMessages) => prevMessages.filter(msg => msg._id !== messageId));
        } catch (error) {
            console.error('Error deleting message for all:', error);
        }
    };

    const handleDeleteMessageForMe = async (messageId) => {
        return;
        try {
            const token = localStorage.getItem('token');
            await axios.post('/api/applicant-to-recruiter-message/delete-message-for-me', { messageId }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setMessages((prevMessages) => prevMessages.filter(msg => msg._id !== messageId));
        } catch (error) {
            console.error('Error deleting message for me:', error);
        }
    };

    const handleMarkRead = async (messageId) => {
        return;
        try {
            const token = localStorage.getItem('token');
            await axios.post('/api/applicant-to-recruiter-message/mark-read', { messageId }, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setMessages((prevMessages) => prevMessages.map(msg => {
                if (msg._id === messageId) {
                    return { ...msg, readBy: [...msg.readBy, { userId, readAt: new Date() }] };
                }
                return msg;
            }));
        } catch (error) {
            console.error('Error marking message as read:', error);
        }
    };

    const formatDate = (date) => {
        const d = new Date(date);
        const now = new Date();
        const isThisYear = d.getFullYear() === now.getFullYear();
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear().toString().slice(-2);
        const hours = d.getHours().toString().padStart(2, '0');
        const minutes = d.getMinutes().toString().padStart(2, '0');
        return isThisYear ? `${hours}:${minutes} ${day}/${month}` : `${hours}:${minutes} ${day}/${month}/${year}`;
    };

    return (
        <div>
            <NavHeader/>
             <div className={styles.applicantMessageContainer}>
                <div className={styles.recruiterList}>
                    <div className={styles.recruiterListHeader}>
                        <h3>💼 Messages</h3>
                        <div className={styles.onlineCount}>
                            {recruiters.length} recruiters
                        </div>
                    </div>
                    <div className={styles.recruiterListContent}>
                        {recruiters.map((recruiter) => (
                            <div 
                                key={recruiter._id} 
                                className={`${styles.recruiterItem} ${activeChat?._id === recruiter._id ? styles.activeRecruiter : ''}`}
                                onClick={() => handleChatClick(recruiter)}
                            >
                                <div className={styles.recruiterAvatar}>
                                    <img 
                                        title={recruiter.name}
                                        src={recruiter.profilePicture ? recruiter.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : '/default-profile.png'}
                                        alt="Profile" 
                                        className={styles.recruiterProfilePicture} 
                                    />
                                    <div className={styles.onlineIndicator}></div>
                                </div>
                                <div className={styles.recruiterDetails}>
                                    <span className={styles.recruiterName}>{recruiter.name}</span>
                                    <span className={styles.companyName}>{recruiter.companyName}</span>
                                    <div className={styles.lastMessage}>
                                        <span className={styles.messagePreview}>Click to start conversation</span>
                                        <span className={styles.messageTime}>now</span>
                                    </div>
                                </div>
                                <div className={styles.unreadBadge}>•</div>
                            </div>
                        ))}
                    </div>
                </div>

                {activeChat ? (
                    <div className={styles.chatPopup}>
                        <div className={styles.chatPopupHeader}>
                            <div className={styles.activeChatDetails}>
                                <button className={styles.backButton} onClick={() => setActiveChat(null)}>
                                    ←
                                </button>
                                <div className={styles.activeChatAvatar}>
                                    <img 
                                        title={activeChat.name}
                                        src={activeChat.profilePicture ? activeChat.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : '/default-profile.png'}
                                        alt="Profile" 
                                        className={styles.activeChatProfilePicture} 
                                    />
                                    <div className={styles.onlineIndicator}></div>
                                </div>
                                <div className={styles.activeChatInfo}>
                                    <h3>{activeChat.name}</h3>
                                    <span className={styles.companyName}>{activeChat.companyName}</span>
                                    <div className={styles.activeStatus}>
                                        <span className={styles.statusDot}></span>
                                        Active now
                                    </div>
                                </div>
                            </div>
                            <button className={styles.closeButton} onClick={() => setActiveChat(null)}>
                                ✕
                            </button>
                        </div>

                        <div className={styles.chatBox}>
                            <div className={styles.messagesContainer}>
                                {messages.map((msg, index) => (
                                    <div key={index} className={`${styles.message} ${msg.senderId === userId ? styles.sent : styles.received}`}>
                                        <div className={styles.messageContent}>
                                            <div className={styles.messageText}>
                                                {msg.message}
                                            </div>
                                            <button 
                                                className={styles.messageOptionsButton} 
                                                onClick={() => setShowOptions(showOptions === index ? null : index)}
                                            >
                                                ⋮
                                            </button>
                                            {showOptions === index && (
                                                <div className={styles.messageOptionsMenu}>
                                                    <button onClick={() => {handleMarkRead(msg._id);setShowOptions(null)}}>
                                                        👁️ Mark as read
                                                    </button>
                                                    <button onClick={() => {handleDeleteMessageForMe(msg._id);setShowOptions(null);}}>
                                                        🗑️ Delete for me
                                                    </button>
                                                    {msg.senderId === userId && (
                                                        <button onClick={() => {handleDeleteMessageForAll(msg._id);setShowOptions(null)}}>
                                                            ⚠️ Delete for everyone
                                                        </button>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className={styles.messageTimestamp}>
                                            {formatDate(msg.createdAt)}
                                        </div>
                                    </div>
                                ))}
                                <div ref={bottomRef} />
                            </div>
                        </div>

                        <div className={styles.inputBox}>
                            <div className={styles.inputContainer}>
                                <input
                                    type="text"
                                    value={recentMessage}
                                    onChange={(e) => setRecentMessage(e.target.value)}
                                    placeholder="Type a message..."
                                    className={styles.messageInput}
                                />
                            </div>
                            <button className={styles.sendButton} onClick={sendMessage}>
                                <span className={styles.sendIcon}>🚀</span>
                                Send
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className={styles.emptyChatState}>
                        <div className={styles.emptyChatIcon}>💬</div>
                        <h3>Select a conversation</h3>
                        <p>Choose a recruiter from the list to start messaging</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default GuestApplicantToRecruiterMessage;